/** @format */

import {styled} from '@mui/material/styles';

import TertiaryMediumButton from 'components/buttons/TertiaryMediumButton';

export const Button = styled(TertiaryMediumButton)(({theme}) => ({
  minWidth: '160px',
  color: 'white',
  background: '#202020',
  marginLeft: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },

  '&:hover': {
    background: '#2a2a2a',
  },
}));
